// API for calling to Login User
async function LoginUserAPI(loginData) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth`, {
    method: "POST",
    body: JSON.stringify({
      username: loginData.username,
      password: loginData.password,
      notification: "",
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((err) => {
    console.log(err);
    return false;
  });

  return response.json();
}

export default LoginUserAPI;
